module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-43.7bd015d1.png";